import controller from './tabs.controller'
import template from './tabs.html';

const module = angular.module('tabs', [

])
.config(($stateProvider) => {
	"ngInject";

	$stateProvider
		.state('tab', {
			url: '/tab',
			abstract: true,
			template: template,
			controller: controller,
			controllerAs: 'tabs',
			resolve: {
				language: Language => Language.translations(),
				user: (User, Socket, $q, $auth, $rootScope, $state, Support, Affiliate) => {
					return User.get().then(res => {
						Socket.bind(res.id);
						Support.setCount(0);
						Affiliate.get();
						$rootScope.user = res;
						return $q.resolve(res);
					}).catch(err => {
						$auth.logout().then(function() {
							$state.go('login');
						});
						return $q.reject(err);
					});
				}
			}
		})
})
.name;

export default module;



// WEBPACK FOOTER //
// ./app/components/tabs/tabs.js